/**
 * Kunjaree — account links use JWT (localStorage), not Shopify customer session alone.
 */
(function(global) {
  'use strict';

  var TOKEN_KEY = 'kunjaree_customer_token';

  function hasAuthToken() {
    try {
      return !!global.localStorage.getItem(TOKEN_KEY);
    } catch (err) {
      return false;
    }
  }

  function accountHref() {
    return hasAuthToken() ? '/pages/account' : '/pages/login';
  }

  function safeReturnTo(value) {
    if (!value || typeof value !== 'string') return '';
    if (value.charAt(0) !== '/' || value.charAt(1) === '/') return '';
    return value;
  }

  function getReturnTo() {
    try {
      return safeReturnTo(new URLSearchParams(global.location.search).get('return_to'));
    } catch (err) {
      return '';
    }
  }

  function updateAccountLinks() {
    document.querySelectorAll('[data-kunjaree-account-link]').forEach(function(el) {
      el.setAttribute('href', accountHref());
    });
  }

  function notifyAuthChange() {
    try {
      global.dispatchEvent(new CustomEvent('kunjaree:auth-change'));
    } catch (err) {}
  }

  global.KunjareeAuth = {
    hasAuthToken: hasAuthToken,
    accountHref: accountHref,
    getReturnTo: getReturnTo,
    safeReturnTo: safeReturnTo,
    updateAccountLinks: updateAccountLinks,
    notifyAuthChange: notifyAuthChange
  };

  document.addEventListener('DOMContentLoaded', updateAccountLinks);
  global.addEventListener('kunjaree:auth-change', updateAccountLinks);
  global.addEventListener('storage', function(e) {
    if (e.key === TOKEN_KEY) updateAccountLinks();
  });
})(window);
